/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateJiraCloudSyncSettingsInput = {
    isJiraToForecastOneWaySync?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateJiraCloudSyncSettingsMutationVariables = {
    input: UpdateJiraCloudSyncSettingsInput;
};
export type updateJiraCloudSyncSettingsMutationResponse = {
    readonly updateJiraCloudSyncSettings: {
        readonly company: {
            readonly integrations: {
                readonly jiraCloud: {
                    readonly syncSettings: {
                        readonly isJiraToForecastOneWaySync: boolean | null;
                    } | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type updateJiraCloudSyncSettingsMutation = {
    readonly response: updateJiraCloudSyncSettingsMutationResponse;
    readonly variables: updateJiraCloudSyncSettingsMutationVariables;
};



/*
mutation updateJiraCloudSyncSettingsMutation(
  $input: UpdateJiraCloudSyncSettingsInput!
) {
  updateJiraCloudSyncSettings(input: $input) {
    company {
      integrations {
        jiraCloud {
          syncSettings {
            isJiraToForecastOneWaySync
          }
          id
        }
        id
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateJiraCloudSyncSettingsInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraSyncSettingsType",
  "kind": "LinkedField",
  "name": "syncSettings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJiraToForecastOneWaySync",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateJiraCloudSyncSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateJiraCloudSyncSettingsPayload",
        "kind": "LinkedField",
        "name": "updateJiraCloudSyncSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyIntegrationsType",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraCloud",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateJiraCloudSyncSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateJiraCloudSyncSettingsPayload",
        "kind": "LinkedField",
        "name": "updateJiraCloudSyncSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyIntegrationsType",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraCloud",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateJiraCloudSyncSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation updateJiraCloudSyncSettingsMutation(\n  $input: UpdateJiraCloudSyncSettingsInput!\n) {\n  updateJiraCloudSyncSettings(input: $input) {\n    company {\n      integrations {\n        jiraCloud {\n          syncSettings {\n            isJiraToForecastOneWaySync\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'cb96b1417f30c32f31535b800e209cdd';
export default node;
